import "@fontsource-variable/inter/index.css"
import "@/styles.css"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { BrowserRouter } from "react-router-dom"
import { App } from "@/app"
import { AppUpdateNotice } from "@/components/app-update-notice"
import { Toaster } from "@/components/ui/toast"
import { AuthProvider } from "@/hooks/use-auth"
import { ThemeProvider } from "@/hooks/use-theme"
import { installPreloadErrorRecovery } from "@/lib/app-update"
import { installNavigationGuard } from "@/lib/navigation-guard"

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, retry: 1, refetchOnWindowFocus: false },
    mutations: { retry: 0 },
  },
})

installNavigationGuard()
installPreloadErrorRecovery()

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ThemeProvider>
      <BrowserRouter>
        <QueryClientProvider client={queryClient}>
          <AuthProvider>
            <App />
            <Toaster timeout={4500} />
            <AppUpdateNotice />
          </AuthProvider>
        </QueryClientProvider>
      </BrowserRouter>
    </ThemeProvider>
  </StrictMode>,
)
